module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services01-7426677606d5cabe6cc0bb8a3955006d.jpg";